import styled from '@emotion/styled';

export const Body = styled.div({
  padding: '15px 0 25px',
  textAlign: 'center',
});